import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CapitalChart from '../../components/chartgraphique/CapitalChart/index.js';
import { getPortefeuilleData, getAllTransactionsByStatus } from '../../Api/authApi.js.js';
import './capitalPleinEcran.css';

const CapitalPleinEcran = () => {
  const userId = useSelector((state) => state.auth.user.id);
  const [portefeuilledata, setPortefeuilledata] = useState([]);
  const [allTxs, setAllTxs] = useState([]);

  useEffect(() => {
    document.title = 'Capital total';
  }, []);

  useEffect(() => {
    if (!userId) return;
    getPortefeuilleData(userId).then(setPortefeuilledata).catch(() => {});
    getAllTransactionsByStatus(userId)
      .then(res => setAllTxs(res.transactions || []))
      .catch(() => {});
  }, [userId]);

  return (
    <div className="capital-plein-ecran-page">
      <div className="capital-plein-ecran-card">
        <CapitalChart portefeuilledata={portefeuilledata} allTxs={allTxs} large />
      </div>
    </div>
  );
};

export default CapitalPleinEcran;
